import React, { useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { TIMESCALE } from '../../commons/api';
import { InboxOutlined } from '@ant-design/icons';

import constant from '../../constants/config.json';
import localStorage from '../../utils/localStorage';
import { message, Upload, Button, Steps } from 'antd';

moment.locale('English');
const { Step } = Steps;

const TableConfigurationUpload = () => {
  const [current, setCurrent] = useState(0);
  const translationCache = useSelector(state => state.TranslationReducer.translationCache);

  const handleChange = (info) => {
    const { status } = info.file;
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const next = () => {
    setCurrent(prev => prev + 1);
  };

  const prev = () => {
    setCurrent(prev => prev - 1);
  };

  const onChange = (current) => {
    setCurrent(current);
  };

  const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 10;
    const isCSV = file.type === 'text/csv';
    if (!isCSV) {
      message.error('You can only upload CSV file!');
    }
    if (!isLt2M) {
      message.error('CSV file must be smaller than 10MB!');
    }
    return isLt2M && isCSV;
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  const Authorization = 'Bearer ' + token;

  const steps = [
    {
      title: translation(constant.Table),
      key: 'table',
      content: (
        <Upload.Dragger
          name="file"
          action={`${TIMESCALE.TableConfig}?SiteId=${siteId}`}
          accept="text/csv"
          multiple={false}
          headers={{
            Authorization: Authorization
          }}
          beforeUpload={beforeUpload}
          onChange={handleChange}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">{translation(constant.Upload_Text)}</p>
          <p className="ant-upload-hint">1.{translation(constant.Upload_Desp1)}</p>
          <p className="ant-upload-hint">2.{translation(constant.Upload_Desp2)}</p>
        </Upload.Dragger>
      )
    }
  ];

  return (
    <div style={{ minHeight: window.innerHeight - 300 }}>
      <div>
        <Steps current={current} type="navigation" onChange={onChange}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>

        <div className="steps-content">{steps[current].content}</div>

        <div className="steps-action">
          {current < steps.length - 1 && (
            <Button type="primary" onClick={next}>
              Next
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button type="primary" onClick={() => message.success('Processing complete!')}>
              {translation(constant.Done)}
            </Button>
          )}
          {current > 0 && (
            <Button style={{ marginLeft: 8 }} onClick={prev}>
              Previous
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableConfigurationUpload;
